(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lender-tor-rule', {
            parent: 'entity',
            url: '/lender/{lenderId}/tor-rules',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.lenderTorRule.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lender-tor-rule/lender-tor-rules.html',
                    controller: 'LenderTorRuleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                lenderId: ['$stateParams', function ($stateParams) {
                    return $stateParams.lenderId;
                }],
                rules: ['$stateParams', 'LenderTorRule', function ($stateParams, LenderTorRule) {
                    return LenderTorRule.getByLender({ lenderId: $stateParams.lenderId }).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('lenderTorRule');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lender-tor-rule.new', {
            parent: 'lender-tor-rule',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lender-tor-rule/lender-tor-rule-dialog.html',
                    controller: 'LenderTorRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: [function () {
                            return {
                                id: null,
                                lenderId: parseInt($stateParams.lenderId, 10),
                                title: null,
                                ruleText: null
                            };
                        }]
                    }
                }).result.then(function () {
                    $state.go('lender-tor-rule', { lenderId: $stateParams.lenderId }, { reload: true });
                }, function () {
                    $state.go('^');
                });
            }]
        })
        .state('lender-tor-rule.edit', {
            parent: 'lender-tor-rule',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lender-tor-rule/lender-tor-rule-dialog.html',
                    controller: 'LenderTorRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LenderTorRule', function (LenderTorRule) {
                            return LenderTorRule.get({ id: $stateParams.id }).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('lender-tor-rule', { lenderId: $stateParams.lenderId }, { reload: true });
                }, function () {
                    $state.go('^');
                });
            }]
        })
        .state('lender-tor-rule.delete', {
            parent: 'lender-tor-rule',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lender-tor-rule/lender-tor-rule-delete-dialog.html',
                    controller: 'LenderTorRuleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LenderTorRule', function (LenderTorRule) {
                            return LenderTorRule.get({ id: $stateParams.id }).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('lender-tor-rule', { lenderId: $stateParams.lenderId }, { reload: true });
                }, function () {
                    $state.go('^');
                });
            }]
        });
    }
})();
